export default {
      id: "Icon--search-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--search",
      toString: function () {
        return this.url;
      }
    }